export const common = {
  nav: {
    home: 'الرئيسية',
    about: 'من نحن',
    products: 'المنتجات',
    affiliate: 'كن شريكاً',
    contact: 'اتصل بنا',
    cart: 'السلة',
  },
  hero: {
    title1: 'اكتشف التشكيلة المميزة',
    title2: 'من المكسرات NOZA',
    tagline: 'مختارة بعناية',
    cta: 'استكشف منتجاتنا',
  },
  about: {
    label: 'قصتنا',
    title1: 'التميز',
    title2: 'الجزائري',
    description: 'ولدت NOZA من شغف بالمكسرات الاستثنائية والتزام بالجودة. مقرها في الجزائر، تختار علامتنا التجارية بدقة كل فستق وكاجو ولوز لتقدم لك تجربة طعم لا تضاهى. تحافظ طرق التحميص الحرفية لدينا على النكهات الطبيعية والفوائد الغذائية. يتم اختيار كل حبة مكسرات يدوياً من قبل خبرائنا، مما يضمن جودة ثابتة ونضارة مثالية. ينعكس التزامنا بالتميز في كل عبوة NOZA.',
    card1Title: '100%',
    card1Subtitle: 'طبيعي',
    card1Text: 'بدون إضافات صناعية',
    card1Tagline: 'النقاء في كل قضمة',
    card2Title: '15+',
    card2Subtitle: 'سنة من الخبرة',
    card2Text: 'في الاختيار المميز',
    cta: 'اكتشف عمليتنا',
  },
  products: {
    title: 'منتجاتنا المميزة',
    subtitle: 'تشكيلة حرفية من المكسرات المميزة',
    viewDetails: 'عرض التفاصيل',
    delivery: 'التوصيل متاح في الجزائر',
  },
  cart: {
    title: 'سلة التسوق',
    empty: 'سلة التسوق فارغة',
    goShopping: 'متابعة التسوق',
    orderSummary: 'ملخص الطلب',
    total: 'المجموع',
    confirm: 'تأكيد الطلب',
    remove: 'إزالة',
    subtotal: 'المجموع الفرعي',
    item: 'منتج',
    items: 'منتجات',
    shippingInfo: 'معلومات الشحن',
    paymentMethod: 'طريقة الدفع',
    cod: 'الدفع عند الاستلام',
  },
  orderType: {
    label: 'نوع الطلب',
    particulier: 'أفراد',
    magasin: 'متجر',
    particulierDesc: 'للأفراد: اطلب أكياسك بكميات صغيرة.',
    magasinDesc: 'للمتاجر: اطلب صندوقاً يحتوي على 10 منتجات نوزا. حدد عدد الصناديق المطلوبة.',
    required: 'يرجى اختيار نوع الطلب',
    boxInfo: 'صندوق واحد = 10 منتجات',
    boxCount: 'عدد الصناديق',
    totalProducts: 'ستحصل على {boxes} صناديق × 10 منتجات = {total} منتج إجمالاً',
    box: 'صندوق',
    boxes: 'صناديق',
    pack: 'كيس',
    packs: 'أكياس',
  },
  toast: {
    addedToCart: 'تمت إضافة {product} إلى السلة!',
    orderConfirmed: 'تم تأكيد الطلب! سوف تتلقى مكالمة أو بريد إلكتروني للتأكيد قريباً.',
    success: 'نجح',
    error: 'خطأ',
  },
  footer: {
    newsletter: 'ابق على اطلاع',
    newsletterDesc: 'احصل على عروضنا الحصرية والأخبار',
    emailPlaceholder: 'عنوان بريدك الإلكتروني',
    subscribe: 'اشترك',
    navigation: 'التنقل',
    contact: 'اتصل بنا',
    address: 'العنوان',
    addressLine1: 'الجزائر العاصمة، الجزائر',
    addressLine2: 'المنطقة الصناعية',
    copyright: '© 2025 NOZA Nuts. جميع الحقوق محفوظة.',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الاستخدام',
  },
  common: {
    learnMore: 'اعرف المزيد',
    orderNow: 'اطلب الآن',
    addToCart: 'أضف إلى السلة',
    submit: 'إرسال',
    close: 'إغلاق',
  },
};